<template>
	<div>
        <nav class="navbar navbar-expand-lg navbar-dark container navbar-small">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor02" aria-controls="navbarColor02" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarColor02">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item active">
                <router-link to='builder' class="nav-link" name="Main">Desktops</router-link> 
              </li>
              <li class="nav-item">
                <router-link to='/compare' class="nav-link" >Compare</router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">Summary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">FAQ</a>
              </li>
              
            </ul>
            <div class="cart-btn"><a href="#">Cart</a></div>
          </div>
        </nav>
      </div>
</template>

<script>
export default {
    name: 'smallnav',
    props: ["viewModes", "items"],
    data() {
        return {
            
        }
    },
    methods: {
        
    },    
}
</script>
<style scoped>
.navbar-dark {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
</style>